import React from 'react';
import { Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { LowboyAssignmentStatuses } from './LowboyAssignmentStatuses';
import { FlexCenterRow } from '../common/forms/FormElements';
import LowboyAssignmentStatusIcon from './LowboyAssignmentStatusIcon';
import LowboyResourceScoreboard from './LowboyResourceScoreboard';

export default class AssignmentActionBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
        };

        this.togglePopover = this.togglePopover.bind(this);
    }

    anyAssignmentsPlanned() {
        const { lowboyAssignments } = this.props;

        return lowboyAssignments.some(
            (la) =>
                la.lowboyAssignmentStatusId == LowboyAssignmentStatuses.Planned
        );
    }

    togglePopover() {
        const { showPopover } = this.state;

        this.setState({ showPopover: !showPopover });
    }

    render() {
        const { assignmentsLoading, onSendNotificationClick } = this.props;
        const { showPopover } = this.state;

        const dispatchEnabled =
            !assignmentsLoading && this.anyAssignmentsPlanned();

        const lowboyAssignmentStatuses = Object.keys(LowboyAssignmentStatuses);

        return (
            <div className="p2 action-bar w-100 mb-2 mt-2 d-flex ">
                <Button
                    color="info"
                    onClick={this.togglePopover}
                    id="popoverLabel"
                    outline={!showPopover}
                    className="ml-2 mr-4 mt-auto mb-auto"
                    title="Assignment Status Key"
                >
                    <FontAwesomeIcon icon={faInfoCircle} />
                </Button>

                <Popover
                    isOpen={showPopover}
                    target="popoverLabel"
                    toggle={this.togglePopover}
                    placement="bottom"
                    fade={false}
                >
                    <PopoverHeader>Assignment Status Key</PopoverHeader>
                    <PopoverBody>
                        <FlexCenterRow className="assignment-legend">
                            {lowboyAssignmentStatuses.map((e) => (
                                <small className="m-1" key={e}>
                                    <LowboyAssignmentStatusIcon
                                        lowboyAssignment={{
                                            lowboyAssignmentStatusId:
                                                LowboyAssignmentStatuses[e],
                                        }}
                                    />{' '}
                                    {e}
                                </small>
                            ))}
                        </FlexCenterRow>
                    </PopoverBody>
                </Popover>

                <LowboyResourceScoreboard {...this.props} />

                <Button
                    type="button"
                    disabled={!dispatchEnabled}
                    className="float-right mr-3 ml-3 mb-auto mt-auto"
                    outline={!dispatchEnabled}
                    color={dispatchEnabled ? 'success' : 'default'}
                    onClick={onSendNotificationClick}
                >
                    <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                    Send Notifications
                </Button>
            </div>
        );
    }
}
